import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card p-2 bg-light border-primary" }
const _hoisted_2 = { class: "row g-2 align-items-end" }
const _hoisted_3 = { class: "col-md-2" }
const _hoisted_4 = { class: "form-label small mb-1" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 2,
  class: "col-md-2"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "col-md-3 d-flex gap-1" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_27 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = {
  class: "alert alert-danger alert-dismissible fade show py-2 mb-0",
  role: "alert"
}
const _hoisted_32 = { class: "mb-0 mt-1 ps-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (
          _ctx.alertType === _ctx.AlertType.FOREX ||
          _ctx.alertType === _ctx.AlertType.SYNTHETIC_INDICES
        )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.alertType === _ctx.AlertType.FOREX ? "Par" : "Índice"), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.target) = $event)),
                disabled: _ctx.isSaving
              }, null, 8, _hoisted_5), [
                [_vModelText, _ctx.form.target]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small mb-1" }, "Dirección", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.direction) = $event)),
                disabled: _ctx.isSaving
              }, [...(_cache[15] || (_cache[15] = [
                _createElementVNode("option", { value: "buy" }, "BUY", -1),
                _createElementVNode("option", { value: "sell" }, "SELL", -1)
              ]))], 8, _hoisted_7), [
                [_vModelSelect, _ctx.form.direction]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label small mb-1" }, "Tipo de Orden", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.orderType) = $event)),
                disabled: _ctx.isSaving
              }, [...(_cache[17] || (_cache[17] = [
                _createStaticVNode("<option value=\"market\">Market</option><option value=\"buy_limit\">Buy Limit</option><option value=\"sell_limit\">Sell Limit</option><option value=\"buy_stop\">Buy Stop</option><option value=\"sell_stop\">Sell Stop</option><option value=\"pending\">Pending</option>", 6)
              ]))], 8, _hoisted_9), [
                [_vModelSelect, _ctx.form.orderType]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label small mb-1" }, "PE", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.00001",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.entryPrice) = $event)),
                disabled: _ctx.isSaving
              }, null, 8, _hoisted_11), [
                [
                  _vModelText,
                  _ctx.form.entryPrice,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label small mb-1" }, "TPs", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.takeProfitStr) = $event)),
                title: "Separados por coma",
                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateTakeProfit && _ctx.updateTakeProfit(...args))),
                disabled: _ctx.isSaving
              }, null, 40, _hoisted_13), [
                [_vModelText, _ctx.takeProfitStr]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label small mb-1" }, "SL", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.00001",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.stopLoss) = $event)),
                disabled: _ctx.isSaving
              }, null, 8, _hoisted_15), [
                [
                  _vModelText,
                  _ctx.form.stopLoss,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_16, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label small mb-1" }, "Cuota", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.oddsError }]),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.odds) = $event)),
                placeholder: "1.85 o +150 o 6/4",
                onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateFields && _ctx.validateFields(...args))),
                disabled: _ctx.isSaving
              }, null, 42, _hoisted_17), [
                [_vModelText, _ctx.form.odds]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label small mb-1" }, "Stake", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.stakeError }]),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.stake) = $event)),
                placeholder: "10% o 10 o 0.1",
                onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.validateFields && _ctx.validateFields(...args))),
                disabled: _ctx.isSaving
              }, null, 42, _hoisted_19), [
                [_vModelText, _ctx.form.stake]
              ])
            ])
          ], 64)),
      (
          _ctx.alertType === _ctx.AlertType.FOREX ||
          _ctx.alertType === _ctx.AlertType.SYNTHETIC_INDICES
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label small mb-1" }, [
              _createTextVNode("Exit Price "),
              _createElementVNode("small", { class: "text-muted" }, "(opcional)")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              step: "0.00001",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.exitPrice) = $event)),
              placeholder: "Precio real de salida",
              disabled: _ctx.isSaving
            }, null, 8, _hoisted_21), [
              [
                _vModelText,
                _ctx.form.exitPrice,
                void 0,
                { number: true }
              ]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label small mb-1" }, "Resultado", -1)),
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-sm",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.resultStatus) = $event)),
          disabled: _ctx.isSaving
        }, [...(_cache[25] || (_cache[25] = [
          _createElementVNode("option", { value: "pending" }, "Pendiente", -1),
          _createElementVNode("option", { value: "win" }, "Ganada", -1),
          _createElementVNode("option", { value: "loss" }, "Perdida", -1),
          _createElementVNode("option", { value: "void" }, "Anulada", -1)
        ]))], 8, _hoisted_23), [
          [_vModelSelect, _ctx.form.resultStatus]
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-success w-100 text-white",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
          disabled: _ctx.isSaving || _ctx.hasValidationErrors
        }, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26))
            : (_openBlock(), _createElementBlock("i", _hoisted_27))
        ], 8, _hoisted_25),
        _createElementVNode("button", {
          class: "btn btn-sm btn-secondary w-100",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('cancel'))),
          disabled: _ctx.isSaving
        }, [...(_cache[27] || (_cache[27] = [
          _createElementVNode("i", { class: "fas fa-times" }, null, -1)
        ]))], 8, _hoisted_28)
      ])
    ]),
    (_ctx.validationErrors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[28] || (_cache[28] = _createElementVNode("strong", null, [
                _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }),
                _createTextVNode("Errores de validación:")
              ], -1)),
              _createElementVNode("ul", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors, (error, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}